import { Button } from '@ds';
import { MdOutlineClear } from 'react-icons/md';
import { FilterDropdown } from '@ui';
import { CountryStatePairFilter } from '@features/components/CountryStatePairFilter';
import { TXCenterListFilters } from '@/api/apis/facilities';
import { UseFiltersType } from '@/hooks/useFilters';
import { useTrialProgramsList } from '@/hooks/useTrialProgramsList';
import { FILTERS_NAMES } from '../config';

type TXCentersFiltersProps = UseFiltersType<TXCenterListFilters>;

export const TXCentersFilters = ({ filters, hasFilters, updateFilters, clearFilters }: TXCentersFiltersProps) => {
  const { trialProgramsList } = useTrialProgramsList();

  return (
    <div className="flex gap-7 items-center">
      <CountryStatePairFilter filters={filters} updateFilters={updateFilters} />
      <FilterDropdown
        title={FILTERS_NAMES.trialProgramIds}
        items={trialProgramsList}
        selectedKeys={filters.trialProgramIds}
        mode="multiple"
        onSelectedKeysChange={(values) => updateFilters(values, 'trialProgramIds')}
      />
      {hasFilters && (
        <Button startContent={<MdOutlineClear size={18} />} size="sm" variant="light" onClick={clearFilters}>
          Clear all
        </Button>
      )}
    </div>
  );
};
